import { Injectable } from "@angular/core";
import { CircularInjectionHelper } from "../../services/circularInjectionHelper";
import { resolve } from "url";

@Injectable()
export class ChangePasswordService {

  constructor(private _circularInjectionHelper: CircularInjectionHelper) { }

  public changePassword(noldPassword: string, newPassword: string): Promise<boolean> {
    const me = this;
    return new Promise((resolve, reject) => {
      me._circularInjectionHelper.yourAppServer.Api.ChangePassword(noldPassword, newPassword)
        .then((response) => {
          if (response) {
            resolve(true);
          } else {
            resolve(false);
          }
        })
        .catch((error) => {
          me._circularInjectionHelper.coreLogService.error("ChangepasswordService.changePassword()", "_circularInjectionHelper.yourAppServer.Api.ChangePassword", error);
          reject();
        });
    });
  }
}
